// Cuanto ocupa una nota, para decidir si se pinta entera o recortada.
//
// Las llamadas de Quo se transcriben solas y la transcripcion entra como una
// nota mas (`📝 Transcripcion: …`, webhooks-quo.routes.ts). Una llamada de diez
// minutos son varios parrafos, asi que UNA nota empujaba las demas fuera de la
// pantalla: "cuando se transcribe la nota de Quo y se van a nota quedan como
// muy larga; me gustaria que el preview sea corto y cuando le den a los .. o a
// la nota se expanda" (Lissette 2026-09-01).
//
// No se mira si la nota es una transcripcion: se mira si es LARGA. Atar esto al
// prefijo "Transcripcion" lo romperia el dia que cambie el texto o llegue de
// otro proveedor, y una nota larga escrita a mano estorba exactamente igual.
//
// El recorte lo hace el CSS (-webkit-line-clamp), no este modulo: cortar el
// texto a mano partiria por la mitad el HTML de una nota con formato y cortaria
// palabras. Aqui solo se decide SI hay que recortar.
import { noteToPlainText } from './noteFormat.js';

// Lineas que se ven con la nota cerrada. Suficiente para saber de que va sin
// tener que abrirla.
export const LINEAS_DE_LA_VISTA_PREVIA = 4;

// Ancho aproximado de una linea en la columna de notas. Sirve para contar los
// renglones que ocupa un parrafo largo sin saltos: sin esto, una transcripcion
// entera en un solo parrafo contaria como UNA linea y no se recortaria nunca,
// que es justo el caso que ella reporto.
const CARACTERES_POR_LINEA = 88;

export function lineasDeLaNota(texto, porLinea = CARACTERES_POR_LINEA) {
  const plano = noteToPlainText(texto).replace(/\s+$/, '');
  if (!plano) return 0;
  const ancho = Math.max(1, porLinea);
  return plano.split('\n').reduce((n, linea) => n + Math.max(1, Math.ceil(linea.length / ancho)), 0);
}

export function esNotaLarga(texto, { lineas = LINEAS_DE_LA_VISTA_PREVIA, porLinea } = {}) {
  return lineasDeLaNota(texto, porLinea) > lineas;
}

// Estilo de la nota cerrada. Recorta por lineas completas y deja los puntos
// suspensivos que ella nombro ("cuando le den a los ..").
export const ESTILO_RECORTADO = {
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: LINEAS_DE_LA_VISTA_PREVIA,
  overflow: 'hidden',
};
